import {
  NavigationError,
  provideRouter,
  Router,
  withComponentInputBinding,
  withNavigationErrorHandler,
  withViewTransitions,
} from '@angular/router';
import { APP_ROUTES } from './routes/app-router';
import {
  BrowserModule,
  provideClientHydration,
  withEventReplay,
} from '@angular/platform-browser';
import {
  APP_INITIALIZER,
  ErrorHandler,
  importProvidersFrom,
  isDevMode,
} from '@angular/core';
import { provideStore } from '@ngrx/store';
import { reducers, metaReducers } from './core/store';
import {
  provideAngularQuery,
  QueryClient,
} from '@tanstack/angular-query-experimental';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { tokenInterceptor } from './core/interceptors/token.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { viewOnlyInterceptor } from './core/interceptors/view-only.interceptor';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideAngularSvgIcon } from 'angular-svg-icon';
import { provideLottieOptions } from 'ngx-lottie';
import { provideAnimations } from '@angular/platform-browser/animations';
import { en_US, provideNzI18n } from 'ng-zorro-antd/i18n';
import { FormsModule } from '@angular/forms';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { getEffects } from './core/effects';
import * as Sentry from '@sentry/angular';
import { NgxCaptchaModule } from 'ngx-captcha';

export const appConfig = {
  providers: [
    provideRouter(
      APP_ROUTES,
      withComponentInputBinding(),
      withViewTransitions(),
      withNavigationErrorHandler(
        (err: NavigationError) => {
          console.log('A navigation error has occurred!!!!!!!!:>> ', err);
        },
        // inject(NavErrorHandler).handle(err)}
      ),
    ),
    importProvidersFrom(BrowserModule),
    importProvidersFrom(NgxCaptchaModule),
    provideStore(reducers, { metaReducers }),
    provideAngularQuery(new QueryClient()),
    provideHttpClient(
      withFetch(),
      withInterceptors([viewOnlyInterceptor, tokenInterceptor, errorInterceptor]),
    ),
    provideAnimationsAsync(),
    provideAngularSvgIcon(),
    provideLottieOptions({
      player: () => import('lottie-web'),
    }),
    provideAnimations(),
    provideNzI18n(en_US),
    importProvidersFrom(FormsModule),
    provideAnimationsAsync(),
    provideStoreDevtools({
      maxAge: 25, // Retains last 25 states
      logOnly: !isDevMode(), // Restrict extension to log-only mode
      autoPause: true, // Pauses recording actions and state changes when the extension window is not open
      trace: false, //  If set to true, will include stack trace for every dispatched action, so you can see it in trace tab jumping directly to that part of code
      traceLimit: 75, // maximum stack trace frames to be stored (in case trace option was provided as true)
      connectInZone: true, // If set to true, the connection is established within the Angular zone
    }),
    // importProvidersFrom(
    //   Angular4PaystackModule.forRoot(environment.paystackKey)
    // ),
    importProvidersFrom(getEffects()),
    provideClientHydration(withEventReplay()),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
};
